import { acpDctDisbursementStates } from './states';

export default (appModule) => {
  appModule.config(acpDctDisbursementStates);
};
